import React, { useState, useEffect, useMemo } from "react";
import {
  Table,
  message,
  Alert,
  Modal,
  Form,
  Input,
  Select,
  Spin,
  Grid,
  ConfigProvider
} from "antd";

import ProcessDeviceMultipleFiles from "./ProcessDeviceMultipleFiles";
import { getAPI, deleteAPI, putAPI } from "../../../config/api/apiConfig";

import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { setListDevice } from "../../../redux/feature/device";
import { LoadingOutlined } from "@ant-design/icons";

const { Option } = Select;
const { useBreakpoint } = Grid;

const ListDevice = () => {
  const [deviceData, setDeviceData] = useState([]);
  const [getDeviceId, setDeviceId] = useState(0);
  const [device, setDevice] = useState({});
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [modal2Open, setModal2Open] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rerenderFlag, setRerenderFlag] = useState(false);


  const screens = useBreakpoint();
  const isSmallScreen = screens.xs || screens.sm;

  const [currentPage, setCurrentPage] = useState(1); // current page
  const [pageSize, setPageSize] = useState(10);

  const dispatch = useDispatch();

  const loggedInUserId = useSelector((state) => state.authenticate.userId);
  const token = useSelector((state) => state.authenticate.userToken);
  const [form] = Form.useForm();

  const deleteDevice = async (userId, deviceId) => {
    try {
      const devices = await deleteAPI(`/delete-device/${userId}/${deviceId}`);
      const filteredData = deviceData.filter(
        (device) => device.id !== deviceId
      );
      setDeviceData(filteredData);
      message.success("Device deleted successfully");
    } catch (err) {
      message.error("Device not deleted");
    }
  };

  const updateDevice = async (userId, deviceId, values) => {
    setLoading(true);
    const deviceToUpdate = {
      userId: parseInt(values.userId, 10),
      deviceName: values.deviceName,
      deviceType: values.deviceType,
      deviceModel: values.deviceModel,
      organisationName: values.organisationName,
      // biometricScanner: values.biometricScanner,
    };
    try {
      const devices = await putAPI(
        `/update-device/${parseInt(userId)}/${parseInt(deviceId)}`,
        deviceToUpdate
      );
      const { data } = devices.data;

      // Update the local state with the new device data
      setDeviceData(prevDeviceData =>
        prevDeviceData.map(dev => (dev.id === deviceId ? { ...dev, ...deviceToUpdate } : dev))
      );
      refreshDevices()

      message.success("Device updated successfully");
      setLoading(false);
      // setDevice({});
      setModal2Open(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
      message.error(err?.response?.data?.message);
      setModal2Open(false);
    }
  };

  const getDevice = async (deviceId) => {
    try {
      const devices = await getAPI(`/get-device/${deviceId}`, token);

      const { data } = devices.data;
      setDevice(data);
    } catch (err) {
      console.log(err);
    }
  };

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 24,
      }}
      spin
    />
  );

  const columns = [
    {
      title: "Device Type",
      dataIndex: "deviceType",
      key: "deviceType",
    },
    {
      title: "Device Name",
      dataIndex: "deviceName",
      key: "deviceName",
    },
    {
      title: "Device Model",
      dataIndex: "deviceModel",
      key: "deviceModel",
    },
    {
      title: "Organisation Name",
      dataIndex: "organisationName",
      key: "organisationName",
    },
    // {
    //   title: "Scanner Name",
    //   dataIndex: "biometricScanner",
    //   key: "biometricScanner",
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Action",
      dataIndex: "",
      key: "x",
      render: (item) => (
        <a
          onClick={async () => {
            setDevice({});
            await getDevice(item.key);
            setDeviceId(item.key);
            setModal2Open(true);
          }}
        >
          <EditOutlined />
        </a>
      ),
    },
    {
      title: "",
      dataIndex: "",
      key: "x",
      render: (item) => {
        return (
          <a onClick={() => deleteDevice(loggedInUserId, item.key)}>
            <DeleteOutlined />
          </a>
        );
      },
    },
  ];

  const columnData = [];


  // dispatch(setListDevice(dataDevice));

  const handleExpand = (expanded, record) => {
    if (expanded) {
      setExpandedRowKeys([record.key]);
    } else {
      setExpandedRowKeys([]);
    }
  };

  

  useEffect(() => {

    const getDevices = async () => {
      const devices = await getAPI(
        `/get-all-devices?page=${currentPage}&limit=${pageSize}`,
        token
      );
      const { data } = devices.data;
      setDeviceData(data);
    };

    getDevices();
    
  }, [currentPage, pageSize]);

  const refreshDevices = async () => {
    try {
      const devices = await getAPI(`/get-all-devices?page=${currentPage}&limit=${pageSize}`, token);
      const { data } = devices.data;
      setDeviceData(data);
    } catch (error) {
      console.error("Error refreshing devices:", error);
    }
  };

  let dataDevice;

  deviceData?.forEach((device) => {
    dataDevice = {
      key: device.id,
      deviceType: device.deviceType,
      deviceName: device.deviceName,
      deviceModel: device.deviceModel,
      organisationName: device.organisationName,
      // biometricScanner: device.biometricScanner,
      status: device.status,
      description: (
        <ProcessDeviceMultipleFiles
        refreshDevices={refreshDevices}
          listedDeviceId={device.id}
          status={device.status}
          organisationName={device.organisationName}
          deviceName={device.deviceName}
        />
      ),
    };
    // dispatch(setListDevice(data));
    // columnData.push(data);
    columnData.push(dataDevice);
  });

  const okButtonProps = {
    loading,
    disabled: loading,
    style: {
      width: "40%",
    },
    className: "nibss-form-btn",
  };

  const handleCancel = () => {
    setModal2Open(false);
    form.resetFields(); // clear form input fields
  };

  return deviceData.length !== 0 ? (
    <>
      {/* <DeviceTableList columns={columns}  dataSource={columnData}/> */}
      
      <Table
        columns={columns}
        scroll={{ x: 768 }}
        responsive={{
          xs: "scroll",
          sm: "scroll",
          md: "scroll",
          lg: "scroll",
          xl: "scroll",
          xxl: "scroll",
        }}
        expandable={{
          expandedRowRender: (record) => {
            //console.loh("record", record.key);
            //setDeviceId(record.key);
            return (
              <p
                style={{
                  margin: 0,
                }}
              >
                {record.description}
              </p>
            );
          },
          rowExpandable: (record) => record.name !== "Not Expandable",

          expandedRowKeys,
          onExpand: handleExpand,
        }}
        dataSource={columnData}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: deviceData.length,
          showTotal: (total) => `Total ${total} items`,
          onChange: (page, pageSize) => {
            setCurrentPage(page);
            setPageSize(pageSize);
          },
        }}
        {...(isSmallScreen && { scroll: { x: "max-content" } })}
      />

      <Modal
        title={`Editing ${device.deviceName} ...`}
        centered
        open={modal2Open}
        onOk={() => {
          form.validateFields().then((values) => {
            updateDevice(loggedInUserId, getDeviceId, values);
            form.resetFields();
          });
        }}
        okButtonProps={okButtonProps}
        onCancel={handleCancel}
      >
        <Form form={form} layout="vertical" className="row-col">
          <Form.Item
            className="username "
            label="Device Name"
            name="deviceName"
            value={device.deviceName}
            initialValue={device.deviceName}
            rules={[
              {
                required: true,
                message: "Please input your device name!",
              },
            ]}
          >
            <Input
              placeholder="Enter your Device Name"
              value={device.deviceName}
            />
          </Form.Item>

          <Form.Item
            className="username"
            label="Device Type"
            name="deviceType"
            value={device.deviceType}
            initialValue={device.deviceType}
            rules={[
              {
                required: true,
                message: "Please input your device type!",
              },
            ]}
          >
            <Select
              placeholder="Select an Device Type"
              value={device.deviceType}
            >
              <Option value="single">Single</Option>
              <Option value="multiple">Multiple</Option>
            </Select>
          </Form.Item>
          <Form.Item
            className="username"
            label="Device Model"
            name="deviceModel"
            value={device.deviceModel}
            initialValue={device.deviceModel}
            rules={[
              {
                required: true,
                message: "Please input Device Model",
              },
            ]}
          >
            <Input placeholder="Device Model" value={device.deviceModel} />
          </Form.Item>
          <Form.Item
            className="username"
            label="Organisation Name"
            name="organisationName"
            value={device.organisationName}
            initialValue={device.organisationName}
            rules={[
              {
                required: true,
                message: "Please input Organisation Name",
              },
            ]}
          >
            <Input
              placeholder="Organisation Name"
              value={device.organisationName}
            />
          </Form.Item>
          {/* <Form.Item
            className="username"
            label="biometric Scanner"
            name="biometricScanner"
            value={device.biometricScanner}
            initialValue={device.biometricScanner}
            rules={[
              {
                required: true,
                message: "Please input organisation Name",
              },
            ]}
          >
            <Input
              placeholder="biometric Scanner"
              value={device.biometricScanner}
            />
          </Form.Item> */}
          <Form.Item
            name="userId"
            style={{ display: "none" }}
            value={loggedInUserId}
            initialValue={loggedInUserId}
          >
            <Input defaultValue={loggedInUserId} />
          </Form.Item>

          {/* <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{ width: "100%" }}
              className="nibss-form-btn"
              loading={loading}
            >
              Update Device
            </Button>
          </Form.Item> */}
        </Form>
      </Modal>
    </>
  ) : deviceData === undefined ? (
    <Spin
      direction="vertical"
      indicator={antIcon}
      style={{
        width: "100%",
        margin: "30% 0",
        marginBottom: "20px",
        padding: "30px 50px",
        textAlign: "center",
        borderRadius: "4px",
      }}
    />
  ) : (
    
    <Alert
      message="No Device "
      description="No pending device for review and approval"
      className="alert"
      showIcon
    />
  
  );
};

export default ListDevice;
